<script setup>
import { ref, computed } from 'vue'
import { useStore } from 'vuex'
import { API, HOST_TULUM } from '@/utils/http'
import { useLayerFetch } from '@/components/layers/useLayerFetch'

import { MonthlyPlanetscope } from '@/components/layers'

const props = defineProps({
  map: {
    type: Object,
    required: true
  },
  beforeId: {
    type: String,
    required: true
  },
  layerId: {
    type: String,
    required: true
  },
  groupId: {
    type: String,
    required: true
  },
  orgId: {
    type: Number,
    required: true
  },
  options: {
    type: Object,
    required: false,
    default: () => ({})
  },
  isVisible: {
    type: Boolean,
    default: true
  }
})

const emit = defineEmits(['isLoaded'])
const store = useStore()
const isLoaded = ref(false)
const isEmpty = ref(false)
const mosaics = ref({
  monthly: [],
  quarterly: []
})

useLayerFetch(computed(() => props.isVisible), {
  onShow: async () => {
    if (isLoaded.value) return

    try {
      const response = await API({
        method: 'GET',
        url: `${HOST_TULUM}/tiles/planetscope/${props.orgId}`
      })

      if (!response.data) return
      mosaics.value = response.data

      if (mosaics.value.monthly.length === 0 && mosaics.value.quarterly.length === 0) {
        isEmpty.value = true
        return
      }

      mosaics.value.monthly.reverse()
      mosaics.value.quarterly.reverse()

      isLoaded.value = true
      emit('isLoaded', isLoaded.value)
    } catch (error) {
      console.error('Failed to load PlanetScope mosaics:', error)
      isEmpty.value = true
      isLoaded.value = true
      emit('isLoaded', isLoaded.value)
    }
  }
})
</script>

<template>
  <div v-if="isLoaded && mosaics?.monthly?.length">
    <MonthlyPlanetscope
      :map="map"
      :mosaics="mosaics.monthly"
      :before-id="beforeId"
      :group-id="groupId"
      :org-id="orgId"
      :layer-id="layerId"
      :options="options"
      :show-controls="false"
    />
  </div>
</template>
